import React, { Component } from "react";
import {
    Container,
    Row,
    Col,
    Card,
    CardBody,
    Form,
    Label,
    Input,
    Button,
    Spinner,
    Alert
} from "reactstrap";
import config from "../../config/config";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import withRouter from "../../components/Common/withRouter";

class EditTourInclusion extends Component {
    constructor(props) {
        super(props);
        this.state = {
            breadcrumbItems: [
                { title: "Tour Inclusion", link: "/tourinclusions" },
                { title: "Edit Tour Inclusion", link: "#" },
            ],
            tourInclusionName: "",
            loading: true,
            error: null,
            submitting: false
        };
    }

    componentDidMount() {
        this.fetchTourInclusionData();
    }


    // Fetch tour data for editing
    fetchTourInclusionData = async () => {
        try {
            const tourinclusionId = this.props.router.params.id;
            const response = await fetch(`${config.API_BASE_URL}/tourinclusions/${tourinclusionId}`);
            const data = await response.json();

            if (response.ok) {
                this.setState({
                    tourInclusionName: data.tourinclusion_name,
                    loading: false
                });
            } else {
                this.setState({ 
                    error: data.message || "Failed to fetch tour data",
                    loading: false 
                });
            }
        } catch (error) {
            this.setState({ 
                error: "Error fetching tour data",
                loading: false 
            });
            console.error("Error fetching tour:", error);
        }
    };

    handleInputChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    handleSubmit = async (e) => {
        e.preventDefault();
        this.setState({ submitting: true });

        try {
            const tourinclusionId = this.props.router.params.id;
            const response = await fetch(`${config.API_BASE_URL}/tourinclusions/${tourinclusionId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    tourinclusion_name: this.state.tourInclusionName,
                }),
            });

            const data = await response.json();

            if (response.ok) {
                console.log("Tour Inclusion updated:", data);
                this.props.router.navigate("/tourinclusions");
            } else {
                console.error("Failed to update tour Inclusion:", data);
                this.setState({ 
                    error: data.message || "Failed to update tour inclusion",
                    submitting: false 
                });
            }
        } catch (error) {
            console.error("Error:", error);
            this.setState({ 
                error: "Error updating tour",
                submitting: false 
            });
        }
    };

    handleCancel = () => {
        this.props.router.navigate("/tourinclusions");
    };

    render() {
        const { loading, error, submitting } = this.state;

        if (loading) {
            return (
                <div className="page-content">
                    <Container fluid>
                        <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                            <Spinner color="primary" />
                        </div>
                    </Container>
                </div>
            );
        }

        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs
                            title="Edit Tour Inclusion"
                            breadcrumbItems={this.state.breadcrumbItems}
                        />
                        
                        {error && (
                            <Alert color="danger" className="mb-3">
                                {error}
                            </Alert>
                        )}
                        
                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <CardBody>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Row>
                                                <Col md={12}>
                                                    <div className="mb-3">
                                                        <Label className="form-label">Tour Inclusion Name</Label>
                                                        <Input
                                                            type="text"
                                                            name="tourInclusionName"
                                                            placeholder="Enter tour inclusion name"
                                                            value={this.state.tourInclusionName}
                                                            onChange={this.handleInputChange}
                                                            required
                                                        />
                                                    </div>
                                                </Col>
                                            </Row>

                                            <Row className="mt-4">
                                                <Col className="d-flex justify-content-end">
                                                    <Button 
                                                        type="submit" 
                                                        color="primary" 
                                                        className="me-2"
                                                        disabled={submitting}
                                                    >
                                                        {submitting ? (
                                                            <>
                                                                <Spinner size="sm" className="me-2" />
                                                                Updating...
                                                            </>
                                                        ) : (
                                                            "Update Tour Inclusion"
                                                        )}
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        color="secondary"
                                                        onClick={this.handleCancel}
                                                        disabled={submitting}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(EditTourInclusion);